module.exports = __webpack_public_path__ + "static/media/warn-voided.0b9d6041.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/warn-voided.svg
// module id = 1240
// module chunks = 0